import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchDataGet } from '../../controll/connection/api';

export const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const validateSession = async () => {
            try {
                const response = await fetchDataGet('user/validateSession');
                if (response.isValid) {
                    setUser(response.user);
                }
            } catch (error) {
                console.error('Session validation failed', error);
            } finally {
                setLoading(false); // Set loading to false after validation
            }
        };

        validateSession();
    }, []);

    const login = (userData) => {
        setUser(userData);
    };

    const logout = async () => {
        try {
            const response = await fetchDataGet('user/signout');
        } catch (error) {
            console.error('Session validation failed', error);
        } finally {
            setLoading(false); // Set loading to false after validation
        }
        setUser(null);
    };

    return (
        <UserContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </UserContext.Provider>
    );
};
